import { ApolloLink, InMemoryCache } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
import { MultiAPILink } from "@habx/apollo-multi-endpoint-link";
import { RestLink } from "apollo-link-rest";
import { camelizer } from "@stadium/helpers/formatter";
import camelCase from "lodash/camelCase";
import snakeCase from "lodash/snakeCase";

// ToDo: Remove this dependency on another service
// eslint-disable-next-line import/no-extraneous-dependencies
import { showError, showPersistentErrorToast } from "@stadium/services/react-toastify";

import { getImpersonatedUser, endImpersonationSession } from "@stadium/helpers/impersonation";

const GENERIC_ERROR_MESSAGE =
  "Error occurred while processing your request, please try again later or contact support if the issue persists";
const emptyObj = {};

export const getRestLink = (linkOptions) => {
  const {
    restEndpoint,
    // customHeaders = emptyObj,
  } = linkOptions || emptyObj;
  return new RestLink({
    uri: restEndpoint,
    fieldNameNormalizer: (key) => camelCase(key),
    fieldNameDenormalizer: (key) => snakeCase(key),
    // responseTransformer: async response => {
    //   const data = await response.json()
    //   return jsonDataFormatter(data)
    // }
  });
};

export const getHttpLink = (linkOptions) => {
  const {
    endpoints,
    default: defaultEndpoint = "",
    // customHeaders = emptyObj,
  } = linkOptions || emptyObj;
  return new MultiAPILink({
    endpoints,
    httpSuffix: "",
    defaultEndpoint,
    createHttpLink: () => createUploadLink(),
  });
};

export const authMiddleware = (token) =>
  new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      },
    }));

    return forward(operation);
  });

export const errorMiddleWare = (user) =>
  onError((err) => {
    const { graphQLErrors, networkError } = err;
    if (graphQLErrors) {
      showError(GENERIC_ERROR_MESSAGE);
    }
    if (networkError) {
      if (networkError.name === "AbortError") {
        return;
      }
      const { response } = networkError;
      const { status = 500 } = response || emptyObj;
      switch (status) {
        case 401: {
          const impersonatedUser = getImpersonatedUser();
          if (impersonatedUser) {
            showPersistentErrorToast({
              message: `Unable to impersonate - (${impersonatedUser}). Please check proper permissions on ${
                user?.email || "current user"
              }.`,
            });
            endImpersonationSession();
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            showError("You are not authorized to perform this action");
          }
          break;
        }
        default:
          showError(GENERIC_ERROR_MESSAGE);
          break;
      }
    }
  });

export const camelizeMiddleWare = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    if (response.data) {
      response.data = camelizer(response.data);
    }
    return response;
  }),
);

export const cache = new InMemoryCache({
  typePolicies: {
    Product: {
      keyFields: (object) => {
        return object.uniqueId || object.id;
      },
    },
  },
});
